import React, { createContext, useState } from "react";
import { Link, Outlet, useLoaderData, useLocation } from "react-router-dom";
import { getPromoCodes } from "../../lib/api";
import { IAPIResponse, IPromoCode } from "../../types/api";
import PromoCodesTable from "./PromoCodesTable";

export const loader = async () => {
    const promoCodes = await getPromoCodes({}, true);

    return {
        promoCodes,
    };
};

export const PromoCodesContext = createContext<{
    promoCodes: IPromoCode[];
    setPromoCodes: React.Dispatch<React.SetStateAction<IPromoCode[]>>;
}>({ promoCodes: [], setPromoCodes: (): void => {} });

const PromoCodes = (): React.JSX.Element => {
    const {
        promoCodes: { promoCodes: loadedPromoCodes },
    } = useLoaderData() as {
        promoCodes: IAPIResponse & { promoCodes: IPromoCode[] };
    };

    const location = useLocation();
    const isOnPomoCodesIndexPage = /league-management\/promo-codes\/?$/.test(
        location.pathname,
    );

    const [promoCodes, setPromoCodes] =
        useState<IPromoCode[]>(loadedPromoCodes);

    return isOnPomoCodesIndexPage ? (
        <>
            <Link
                to={`/league-management/promo-codes/add`}
                className="btn btn-primary"
            >
                Add Promo Code
            </Link>
            <br />
            <PromoCodesContext.Provider value={{ promoCodes, setPromoCodes }}>
                <PromoCodesTable />
            </PromoCodesContext.Provider>
        </>
    ) : (
        <PromoCodesContext.Provider value={{ promoCodes, setPromoCodes }}>
            <Outlet />
        </PromoCodesContext.Provider>
    );
};

export default PromoCodes;
